import React, { useState, useEffect } from 'react';
import { Grid, Paper } from '@material-ui/core';
import SearchIcon from "@material-ui/icons/Search";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Link } from 'react-router-dom';
import ModalFrame from "../../biztran_controls/Modal_Frame";
import BiztranControls from '../../biztran_controls/BiztranControls';
import BiztranControlsFormik from '../../biztran_controls_formik/BiztranControlsFormik';
import UseFetchData from '../../../hooks/UseFetchData';
//import CreateServiceCentre from './CreateServiceCentre';
import { Email } from '@material-ui/icons';
import CreateEmployeeMaster from './CreateEmployeeMaster';
// import CreateCall from './CreateCall';

const EmployeeMaster = (props) => {
  debugger;
  const [EmpID, setEmpID] = useState('');
  const [EmpCode, setEmpCode] = useState('');
  const [EmpName, setEmpName] = useState('');
  const [EmpPassword, setEmpPassword] = useState('');
  const [CategoryID, setCategoryID] = useState('');
  const [Mode, setMode] = useState("");
  // const [CallDate,setCallDate] = useState(Moment(new Date()).format("YYYY-MM-DD"));
  const [ApproverID, setApproverID] = useState('');
  const [MobileNo, setMobileNo] = useState('');
  const [Address, setAddress] = useState('');
  const [BankAccountName, setBankAccountName] = useState('');
  const [BankName, setBankName] = useState('');
  const [BankBranch, setBankBranch] = useState('');
  const [IFSCCode, setIFSCCode] = useState('');
  const [IsActive, setIsActive] = useState('');
  const [CreatedByID, setCreatedByID] = useState('');
  const [CreatedOn, setCreatedOn] = useState('');
  const [ModifiedByID, setModifiedByID] = useState('');
  const [ModifiedOn, setModifiedOn] = useState('');
  const [EmailID, setEmailID] = useState('');

  const [ServiceCentreID, setServiceCentreID] = useState('');
  const [CallID, setCallID] = useState('');
  const [ServiceCentreName, setServiceCentreName] = useState('');
  const [CallNo, setCallNo] = useState('');
  const [CallDate, setCallDate] = useState('');
  const [SerialNo, setSerialNo] = useState('');
  const [Address1, setAddress1] = useState('');
  const [Phone, setPhone] = useState('');
  const [State, setState] = useState('');
  const [City, setCity] = useState('');
  const [CustomerName, setCustomerName] = useState('');
  const [UserName, setUserName] = useState('');
  const [CallTray, setCallTray] = useState('');
  const [ProductName, setProductName] = useState('');
  const [Email, setEmail] = useState('');
  const [IsSpamCall, setIsSpamCall] = useState('');
  const [SpamCallRemarks, setSpamCallRemarks] = useState('');
  const [ModelCode, setModelCode] = useState('');
  const [ProductCategoryName, setProductCategoryName] = useState('');
  const [Complaint, setComplaint] = useState('');
  const [DefectName, setDefectName] = useState('');
  const [CallCreatedBy, setCallCreatedBy] = useState('');
  // const [MobileNo,setMobileNo] = useState('');
  const [customercode, setcustomercode] = useState('');
  const [SatisfactionCode, setSatisfactionCode] = useState('');
  // const [ConveyencePreKm,setConveyencePreKm] = useState('');
  // const [PinCode,setPinCode] = useState('');
  // const [PANNo,setPANNo] = useState(''); 
  // const [VATNo,setVATNo] = useState('');
  // const [ServiceTaxNo,setServiceTaxNo] = useState('');
  // const [ASIID,setASIID] = useState('');
  // const [RMID,setRMID] = useState(''); 
  // const [SEID,setSEID] = useState('');
  // const [BranchID,setBranchID] = useState('');
  const [response, fetchData] = UseFetchData();
  const [responseGetData, fetchGetData] = UseFetchData();
  const [Count, setCount] = useState();
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [isOpen, setOpen] = useState(false);


  // const validationSchema = Yup.object({
  //     InputName:Yup.string().required('Required!'),
  // });
  const PopulateData = () => {
    debugger;
    var bodyFormData = new FormData();
    bodyFormData.append("EmpName", EmpName);
    fetchData("Primary/ListEmployee", bodyFormData);
  }


  // const onSubmit = values => {
  //     var bodyFormData = new FormData();
  //     bodyFormData.append("Type", props.Name);
  //     bodyFormData.append("PKID", props.PKID);
  //     bodyFormData.append("Value1", values.InputName);
  //     fetchData("Primary/Save", bodyFormData);
  // };

  // const getByIDData = () => {
  //     var bodyFormData = new FormData();
  //     bodyFormData.append("Type", props.Name);
  //     bodyFormData.append("PKID", props.PKID);
  //     fetchGetData("Primary/GetByID", bodyFormData);
  // }

  const handleOpenModal = () => {
    // setEmpID(EmpID)
    setOpen(true);
    setEmpID("");
  };
  // const openModal = (row) => {
  //   setOpen(true);
  //   setEmpID(row.id);
  // };
  const openModal = (params) => {
    debugger;
    setMode("Update");
    setEmpID(props.EmpID);
    // setOpen(true);
    if (params !== undefined) {
      ;
      setEmpID(params.id);
      setOpen(true);
    } else {
      setEmpID('');
      setOpen(true);
    }
    // setEmpID(EmpID);
  };


  useEffect(() => {
    const gridCols = [
      {
        field: "id",
        headerName: ".",
        // renderCell: (params) => (<strong> <Link to={{ pathname: "/Employeemaster/CallRegistrationView", state: { CallID: params.id } }} style={{ color: 'blue' }} >View</Link> </strong>),
        renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params); }} >Edit</a> </strong>),
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 80,
      },
      {
        field: "EmpCode",
        headerName: "Emp Code",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "EmpName",
        headerName: "Emp Name",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      // {
      //   field: "EmpPassword",
      //   headerName: "Emp Password",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 150,
      // },
      {
        field: "EmailID",
        headerName: "Email",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "MobileNo",
        headerName: "Mobile No",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "Category",
        headerName: "Category",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      },
      {
        field: "Address",
        headerName: "Address",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      // {
      //   field: "ApproverID",
      //   headerName: "Approver",
      //   hide: true,
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 150,
      // },
      {
        field: "BankAccountName",
        headerName: "Bank Account Name",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "BankName",
        headerName: "Bank Name",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      // {
      //   field: "BankBranch",
      //   headerName: "Bank Branch",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 150,
      // },
      // {
      //   field: "IFSCCode",
      //   headerName: "IFSC Code",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 150,
      // },
      {
        field: "IsActive",
        headerName: "IsActive",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      // {
      //   field: "CreatedByID",
      //   headerName: "Created By ID",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   hide: true,
      //   width: 150,
      // },
      // {
      //   field: "CreatedOn",
      //   headerName: "Created On",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 150,
      // },
      // {
      //   field: "ModifiedByID",
      //   headerName: "Modified By ID",
      //   hide: true,
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 150,
      // },
      // {
      //   field: "ModifiedOn",
      //   headerName: "Modified On",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 150,
      // },

    ];
    setColumns(gridCols);
    setRows(response);
    setCount(response.length);

  }, [response]
  );
  useEffect(() => {
    PopulateData();
  }, [])

  //   useEffect(() => {
  //     if (flag === true) {
  //         flag = false
  //         PopulateData()
  //     }

  // }, []
  // );

  // useEffect(() => {
  //     if(response.Response === true){
  //         props.setOpen(false);
  //         props.PopulateData();
  //         alert('Saved Succesfully.')
  //     }
  //     else if(response.Response === false){
  //         alert('Save Failed.')
  //     }
  // },[response])

  // useEffect(() => {
  //     if(responseGetData.length > 0){
  //         const name = props.Name
  //       //  setInputName(responseGetData[0][name])
  //     }
  // },[responseGetData])

  // useEffect(() => {
  //     if(props.PKID !== ''){
  //         getByIDData();
  //     }
  // },[])

  return (
    <div>
      <Formik
        //initialValues={{InputName:InputName}} 
        // validationSchema = {validationSchema} 
        // onSubmit = {onSubmit} 
        enableReinitialize>
        {formik => {
          return <Form>
            {/* <Grid spacing={2} container> */}
            <Grid spacing={1} item xs={12} container direction="row">
              <Grid item xs={2} >
                <BiztranControls.Input
                  control="input"
                  name="EmpName"
                  label="Emp Name"
                  id={EmpName}
                  // ref={ref}
                  value={EmpName}
                  onChange={(e) => setEmpName(e.target.value)}
                />
              </Grid>
              {/* <Grid item xs={2} >
                  <BiztranControls.Input
                    control="input"
                    name="CallNo"
                    label="Call Number"
                    id={CallNo}
                     //ref={ref}
                    value={CallNo}                  
                    onChange={(e) => setCallNo(e.target.value)}
                  />
                </Grid> */}
              {/* <Grid item xs={2} >
                  <BiztranControls.Input
                    control="input"
                    type="text"
                    name="SerialNo"
                    label="Serial Number"
                    id={SerialNo}
                    //ref={ref}
                    value={SerialNo}                  
                    onChange={(e) => setSerialNo(e.target.value)}
                  />
                </Grid> */}
              <Grid item xs={6} >
                <BiztranControls.Button
                  text="SEARCH "
                  startIcon={<SearchIcon />}
                  style={{ width: "18%" }}
                  onClick={() => {
                    PopulateData();
                  }}
                />
                <label style={{ fontWeight: 'bold', width: 12 }}>{Count}</label>

                <BiztranControls.Button
                  text="ADD NEW"
                  startIcon={<AddCircleOutlineIcon />}
                  onClick={() => {
                    handleOpenModal();
                  }}
                />
                {/* <strong> <Link to={{ pathname: "/crm/Transactions/AdvanceSearch" }} style={{ color: 'blue' }} >ADVANCE SEARCH</Link></strong>
      */}
                {/* <BiztranControls.Button
                      text="ADVANCE SEARCH"
                      startIcon={<SearchIcon />}
                      style={{ width: "30%" }}
                      // onClick={() => {
                      //   handleOpenModal();
                      // }}
                    /> */}
              </Grid>
            </Grid>
            <div style={{ marginTop: 20 }}>
              <BiztranControls.DataGrid
                rowHeight={25}
                headerHeight={34}
                rows={rows}
                columns={columns}
                checkboxSelection={false}
                // autoHeight={true}
                Height="490px"
                Width="107%"
                hideFooter={false}

              />
            </div>
          </Form>
        }}
      </Formik>

      <ModalFrame
        title=" Add/Edit Employee Details "
        maxWidth="md"
        isOpen={isOpen}
        setOpen={setOpen}
      >
        <CreateEmployeeMaster
          EmpID={EmpID}
          setOpen={setOpen}
          PopulateData={PopulateData}
        />
      </ModalFrame>
    </div>

  );
}
export default EmployeeMaster;
